<template>
  <!-- participantsInWeekDay, 
sortedParticipantsInWeekDayCompare, sortedParticipantsInWeekDay, participantsInTime, sortedParticipantsInTime, -->
  <v-container>
    <v-card class="pa-5">
      <v-tabs
        fixed-tabs
        background-color="grey lighten-2"
        color="grey darken-1"
        next-icon="mdi-arrow-right-bold-box-outline"
        prev-icon="mdi-arrow-left-bold-box-outline"
        :show-arrows="$vuetify.breakpoint.xs"
      >
        <v-tab>Semester</v-tab>
        <v-tab-item class="pt-5"
          ><!-- Participants of the Semester -->
          <div v-if="participantsSemester.length">
            <v-container>
              <LineChart
                :label="this.latestCourse.name"
                :chart-data="this.participantsSemester"
                :options="{
                  responsive: true,
                  maintainAspectRatio: false,
                  scales: {
                    yAxes: [
                      {
                        display: true,
                        ticks: {
                          beginAtZero: true,
                          min: 0,
                          suggestedMax: 50,
                          stepSize: 10,
                        },
                      },
                    ],
                  },
                }"
              >
              </LineChart>
              <div
                class="text-caption d-flex justify-center py-3"
                style="opacity: 0.8"
              >
                Anzahl Teilnehmer im Semester
              </div>
            </v-container>
          </div></v-tab-item
        >

        <!-- Teilnehmer der Tutorstunden an Wochentagen -->
        <v-tab>Wochentage</v-tab>
        <v-tab-item class="pt-5 text-center"
          ><div v-if="latestCourse">
            <v-row no-gutters>
              <v-col class="mr-sm-3" cols="12" sm="6">
                <v-select
                  label="Woche"
                  outlined
                  v-model="participantsInWeekDay.value"
                  id="weekSelect"
                  :items="
                    getWeeks(latestCourse.startDate, latestCourse.endDate)
                  "
                ></v-select
              ></v-col>
              <v-col class="ml-sm-3">
                <v-select
                  label="Woche zum Vergleich"
                  outlined
                  v-model="participantsInWeekDay.valueToCompare"
                  id="weekSelect"
                  :disabled="!participantsInWeekDay.value"
                  :items="
                    getWeeks(latestCourse.startDate, latestCourse.endDate)
                  "
                ></v-select
              ></v-col>
            </v-row>
            <div v-if="participantsInWeekDay.showChart">
              <v-divider></v-divider>
              <v-row no-gutters style="text-align: center" class="mb-3">
                <v-col cols="6"
                  ><v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 25%">
                            Wochentag
                          </th>
                          <th class="text-center" style="width: 25%">
                            Teilnehmer
                          </th>
                          <th class="text-center" style="width: 25%">
                            Tutorstunden
                          </th>
                          <th class="text-center" style="width: 25%">
                            Kennzahl
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="day in sortedParticipantsInWeekDay"
                          :key="day.date"
                        >
                          <td
                            class="text-center"
                            style="border-right: thin solid #eeeeee"
                          >
                            {{ day.date }}
                          </td>
                          <td class="text-center">{{ day.participants[0] }}</td>
                          <td class="text-center">{{ day.participants[1] }}</td>
                          <td class="text-center">
                            {{
                              day.participants[1] == 0
                                ? 0
                                : (
                                    day.participants[0] / day.participants[1]
                                  ).toFixed(2)
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table></v-col
                >
                <v-col
                  v-if="sortedParticipantsInWeekDayCompare.length"
                  cols="6"
                >
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 25%">
                            Teilnehmer
                          </th>
                          <th class="text-center" style="width: 25%">
                            Tutorstunden
                          </th>
                          <th class="text-center" style="width: 25%">
                            Kennzahl
                          </th>
                          <th class="text-center" style="width: 25%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="day in sortedParticipantsInWeekDayCompare"
                          :key="day.date"
                        >
                          <td
                            class="text-center"
                            style="border-left: thin solid #eeeeee"
                          >
                            {{ day.participants[0] }}
                          </td>
                          <td class="text-center">{{ day.participants[1] }}</td>
                          <td class="text-center">
                            {{
                              day.participants[1] == 0
                                ? 0
                                : (
                                    day.participants[0] / day.participants[1]
                                  ).toFixed(2)
                            }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </template> </v-simple-table
                ></v-col>
              </v-row>
              <AreaChart
                :chart-data="{
                  lastWeek: sortedParticipantsInWeekDayCompare,
                  thisWeek: sortedParticipantsInWeekDay,
                }"
                :options="{
                  responsive: true,
                  maintainAspectRatio: false,
                  scales: {
                    yAxes: [
                      {
                        display: true,
                        ticks: {
                          beginAtZero: true,
                          min: 0,
                          suggestedMax: 50,
                          stepSize: 10,
                        },
                      },
                    ],
                  },
                }"
              >
              </AreaChart>
              <div
                class="text-caption d-flex justify-center py-3"
                style="opacity: 0.8"
              >
                Anzahl Teilnehmer an Wochentagen
              </div>
            </div>
          </div></v-tab-item
        >
        <v-tab>Zeitslots</v-tab>
        <v-tab-item class="pt-5">
          <div v-if="latestCourse">
            <v-select
              label="Woche"
              outlined
              v-model="participantsInTime.value"
              id="weekSelect"
              :items="getWeeks(latestCourse.startDate, latestCourse.endDate)"
            ></v-select>
            <div v-if="participantsInTime.showChart">
              <v-divider />
              <v-simple-table dense class="pb-3">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 25%">Beginn</th>
                      <th class="text-center" style="width: 25%">Teilnehmer</th>
                      <th class="text-center" style="width: 25%">
                        Tutorstunden
                      </th>
                      <th class="text-center" style="width: 25%">Kennzahl</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="time in sortedParticipantsInTime"
                      :key="time.date"
                    >
                      <td class="text-center">{{ time.date }}</td>
                      <td class="text-center">{{ time.participants[0] }}</td>
                      <td class="text-center">{{ time.participants[1] }}</td>
                      <td class="text-center">
                        {{
                          time.participants[1] == 0
                            ? 0
                            : (
                                time.participants[0] / time.participants[1]
                              ).toFixed(2)
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <LineChart
                :label="this.getWeekString(this.participantsInTime.value)"
                :chart-data="this.sortedParticipantsInTime"
                :options="{
                  responsive: true,
                  maintainAspectRatio: false,
                  scales: {
                    yAxes: [
                      {
                        display: true,
                        ticks: {
                          beginAtZero: true,
                          min: 0,
                          suggestedMax: 50,
                          stepSize: 10,
                        },
                      },
                    ],
                  },
                }"
              >
              </LineChart>
              <div
                class="text-caption d-flex justify-center py-3"
                style="opacity: 0.8"
              >
                Anzahl Teilnehmer an Zeitslots
              </div>
            </div>
          </div>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import LineChart from "@/components/LineChart.vue";
import AreaChart from "@/components/AreaChart.vue";

export default {
  components: { LineChart, AreaChart },
  data() {
    return {
      participantsSemester: [],
      currentCourse: [],
      participantsInWeekDay: {
        value: "",
        valueToCompare: "",
        showChart: false,
      },
      participantsDictInWeekDay: {},
      participantsDictInWeekDayCompare: {},
      participantsInTime: { value: "", showChart: false },
      participantsDictInTime: {},
    };
  },
  computed: {
    latestCourse() {
      const selectedCourse = localStorage.getItem("selectedCourse");
      if (selectedCourse) {
        const course = this.currentCourse.find((x) => x.id == selectedCourse);
        if (course) {
          return course;
        } else {
          return this.currentCourse[this.currentCourse.length - 1];
        }
      } else {
        return this.currentCourse[this.currentCourse.length - 1];
      }
    },
    sortedParticipantsInWeekDay() {
      const returnString = [];
      if (
        this.participantsDictInWeekDay &&
        Object.keys(this.participantsDictInWeekDay).length
      ) {
        returnString.push({
          date: "Mo",
          participants: this.participantsDictInWeekDay["Mo"],
        });
        returnString.push({
          date: "Di",
          participants: this.participantsDictInWeekDay["Di"],
        });
        returnString.push({
          date: "Mi",
          participants: this.participantsDictInWeekDay["Mi"],
        });
        returnString.push({
          date: "Do",
          participants: this.participantsDictInWeekDay["Do"],
        });
        returnString.push({
          date: "Fr",
          participants: this.participantsDictInWeekDay["Fr"],
        });
      }
      return returnString;
    },
    sortedParticipantsInWeekDayCompare() {
      const returnString = [];
      if (
        this.participantsDictInWeekDayCompare &&
        Object.keys(this.participantsDictInWeekDayCompare).length
      ) {
        returnString.push({
          date: "Mo",
          participants: this.participantsDictInWeekDayCompare["Mo"],
        });
        returnString.push({
          date: "Di",
          participants: this.participantsDictInWeekDayCompare["Di"],
        });
        returnString.push({
          date: "Mi",
          participants: this.participantsDictInWeekDayCompare["Mi"],
        });
        returnString.push({
          date: "Do",
          participants: this.participantsDictInWeekDayCompare["Do"],
        });
        returnString.push({
          date: "Fr",
          participants: this.participantsDictInWeekDayCompare["Fr"],
        });
      }

      return returnString;
    },
    sortedParticipantsInTime() {
      const returnString = [];
      const keys = Object.keys(this.participantsDictInTime).sort();
      for (let i = 0; i < keys.length; i++) {
        returnString.push({
          date: keys[i],
          participants: this.participantsDictInTime[keys[i]],
        });
      }
      return returnString;
    },
  },
  mounted() {
    Promise.allSettled([this.$axios.get("courses")]).then((req) => {
      if (!(req instanceof Array) || !req.length) return;
      if (req[0].value.data instanceof Array && req[0].value.data.length) {
        const courses = req[0].value.data;
        for (let i = 0; i < courses.length; i++) {
          const course = {
            id: courses[i]["id"],
            startDate: courses[i]["start_date"],
            endDate: courses[i]["end_date"],
            name: courses[i]["name"],
          };
          this.currentCourse.push(course);
        }
      }
      const latest = this.latestCourse;
      if (!latest) return;
      this.$axios
        .get("tutor_sessions/get_participants_semester/", {
          params: {
            // eslint-disable-next-line @typescript-eslint/camelcase
            start_date: latest.startDate,
            // eslint-disable-next-line @typescript-eslint/camelcase
            end_date: latest.endDate,
          },
        })
        .then((req) => {
          if (req.data instanceof Array) {
            req.data.sort((x, y) => x["date"].localeCompare(y["date"]));
            for (let i = 0; i < req.data.length; i++) {
              if (req.data[i]["date"]) {
                req.data[i]["date"] = this.getWeekString(req.data[i]["date"]);
              }
              this.participantsSemester.push(req.data[i]);
            }
          }
        });
    });
  },
  methods: {
    getWeekString(mondayString) {
      const monday = new Date(mondayString);
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      const returnMonday = monday.toLocaleDateString("de-DE", options);
      const returnFriday = new Date(
        monday.setDate(monday.getDate() + 4)
      ).toLocaleDateString("de-DE", options);
      return returnMonday + "~" + returnFriday;
    },
    getWeeks(startDateString, endDateString) {
      const startDate = this.getMonday(new Date(startDateString));
      const endDate = this.getMonday(new Date(endDateString));
      const oneDay = 1000 * 60 * 60 * 24;
      const diff = Math.abs((endDate.valueOf() - startDate.valueOf()) / oneDay);
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      const returnString = [];
      for (let i = 0; i <= diff; i = i + 7) {
        let d = this.getMonday(new Date(startDateString));
        const dayStringMonday = new Date(
          d.setDate(d.getDate() + i)
        ).toLocaleDateString("de-DE", options);
        d = this.getMonday(new Date(startDateString));
        const dayStringFriday = new Date(
          d.setDate(d.getDate() + i + 4)
        ).toLocaleDateString("de-DE", options);
        const week = dayStringMonday + " ~ " + dayStringFriday;
        returnString.push({
          text: week,
          value: this.getMondayString(week),
        });
      }
      return returnString;
    },
    getMonday(d) {
      const day = d.getDay();
      const diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    },
    getMondayString(weekString) {
      const words = weekString.split(" ");
      if (words[0]) {
        const date = words[0].split(".");
        return date[2] + "-" + date[1] + "-" + date[0];
      }
      return words[0];
    },
  },
  watch: {
    "participantsInWeekDay.value": {
      handler: function (newVal, oldVal) {
        // new value
        if (newVal != oldVal) {
          if (!newVal) return;
          this.$axios
            .get("tutor_sessions/get_week_participants/", {
              params: { group: newVal },
            })
            .then((req) => {
              if (req.data instanceof Array) {
                this.participantsDictInWeekDay = {};
                this.participantsInWeekDay.showChart = false;
                for (let i = 0; i < req.data.length; i++) {
                  if (this.participantsDictInWeekDay[req.data[i][0]]) {
                    if (req.data[i][1]) {
                      this.participantsDictInWeekDay[req.data[i][0]][0] +=
                        req.data[i][1];
                    }
                    this.participantsDictInWeekDay[req.data[i][0]][1] += 1;
                  } else {
                    if (req.data[i][1]) {
                      this.participantsDictInWeekDay[req.data[i][0]] = [
                        req.data[i][1],
                      ];
                    } else {
                      this.participantsDictInWeekDay[req.data[i][0]] = [0];
                    }
                    this.participantsDictInWeekDay[req.data[i][0]].push(1);
                  }
                }
                this.participantsInWeekDay.showChart = true;
              }
            });
        }
        // new compare value
      },
    },
    "participantsInWeekDay.valueToCompare": {
      handler: function (value, oldValue) {
        if (value) {
          this.$axios
            .get("tutor_sessions/get_week_participants/", {
              params: { group: value },
            })
            .then((req) => {
              if (req.data instanceof Array) {
                this.participantsDictInWeekDayCompare = {};
                this.participantsInWeekDay.showChart = false;
                for (let i = 0; i < req.data.length; i++) {
                  if (this.participantsDictInWeekDayCompare[req.data[i][0]]) {
                    if (req.data[i][1]) {
                      this.participantsDictInWeekDayCompare[
                        req.data[i][0]
                      ][0] += req.data[i][1];
                    }
                    this.participantsDictInWeekDayCompare[
                      req.data[i][0]
                    ][1] += 1;
                  } else {
                    if (req.data[i][1]) {
                      this.participantsDictInWeekDayCompare[req.data[i][0]] = [
                        req.data[i][1],
                      ];
                    } else {
                      this.participantsDictInWeekDayCompare[req.data[i][0]] = [
                        0,
                      ];
                    }
                    this.participantsDictInWeekDayCompare[req.data[i][0]].push(
                      1
                    );
                  }
                }
                this.participantsInWeekDay.showChart = true;
              }
            });
        }
      },
    },
    "participantsInTime.value": {
      handler: function (value, oldValue) {
        if (value !== "") {
          this.$axios
            .get("tutor_sessions/get_week_participants/", {
              params: { group: value, time: value },
            })
            .then((req) => {
              if (req.data instanceof Array) {
                this.participantsDictInTime = {};
                this.participantsInTime.showChart = false;
                for (let i = 0; i < req.data.length; i++) {
                  if (this.participantsDictInTime[req.data[i][0]]) {
                    if (req.data[i][1]) {
                      this.participantsDictInTime[req.data[i][0]][0] +=
                        req.data[i][1];
                    }
                    this.participantsDictInTime[req.data[i][0]][1] += 1;
                  } else {
                    if (req.data[i][1]) {
                      this.participantsDictInTime[req.data[i][0]] = [
                        req.data[i][1],
                      ];
                    } else {
                      this.participantsDictInTime[req.data[i][0]] = [0];
                    }
                    this.participantsDictInTime[req.data[i][0]].push(1);
                  }
                }
                this.participantsInTime.showChart = true;
              }
            });
        }
      },
    },
  },
};
</script>

<style scoped>
button {
  background-color: transparent !important;
}
td {
  padding: 1rem !important;
}
</style>

<style>
table {
  border-collapse: unset !important;
}
</style>
